<!-- Copyright (c) 2025 Digital Systems (M) Sdn. Bhd. -->

<template>
  <div class="main">
    <div class="left-container">
      <div style="display: flex; width: 100%">
        <div
          style="
            background-color: white;
            border-radius: 5px;
            width: 100%;
            display: flex;
            align-items: center;
            padding: 0px 10px;
            gap: 10px;
          "
        >
          <div style="font-weight: bold; font-size: 1rem">Date Range</div>
          <DateTimePicker
            style="padding-top: 5px"
            :showTime="false"
            :isRequired="true"
            :value.sync="dateStart"
            placeholder="Start"
            @dateChanged="dateEnd = null"
          />
          to
          <DateTimePicker
            style="padding-top: 5px"
            :showTime="false"
            :value.sync="dateEnd"
            :minDate="dateStart"
            placeholder="End"
            :isDisabled="!dateStart"
          />
        </div>
      </div>
      <div :class="['table-wrapper', { open: warehouseOpen }]">
        <div class="accordion-header" @click="warehouseOpen = !warehouseOpen"> Warehouse </div>
        <TableBox
          :tableData="warehouseList"
          :selectedRow.sync="warehouseListTableSelectedRows"
          title=""
          :loading="warehouseListTableLoading"
          :maxSelection="-1"
          :hideColumns="[]"
          :showSelectAll="true"
          style="min-height: 0"
        />
      </div>
      <div :class="['table-wrapper', { open: partTypeOpen }]">
        <div class="accordion-header" @click="partTypeOpen = !partTypeOpen"> Part Type </div>
        <TableBox
          :tableData="partTypeList"
          :selectedRow.sync="partTypeListTableSelectedRows"
          title=""
          :loading="partTypeListTableLoading"
          :maxSelection="-1"
          :hideColumns="[
            'Expense Code',
            'Unique Code',
            'Is Expense',
            'Unit Price',
            'Active',
            'label',
            'ProdTxnID',
            'Size',
          ]"
          :showSelectAll="true"
          style="min-height: 0"
        />
      </div>
      <div style="display: flex; gap: 5px; justify-content: end; width: 100%; margin-top: auto">
        <div style="background-color: white; border-radius: 4px; padding: 2px 4px; width: 100%">
          <Dropdown
            placeholder="Stock Balance Format"
            :isRequired="true"
            :items="reportTypeList"
            itemKey="label"
            :selectedObject.sync="reportTypeValue"
          />
        </div>
        <Button style="width: fit-content; flex: 0 0 auto" :disabled="previewDisabled" @click="previewClicked"
          >Preview Stock Balance</Button
        ></div
      >
    </div>
    <div class="right-container">
      <DesignerV3
        v-if="showDesignerV3"
        :reportFiles="designerV3ReportFiles"
        :reportData="designerV3ReportData"
        :sharedData="designerV3SharedData"
        :canShare="true"
        :shareBehaviour="designerV3ShareBehaviour"
        :canClose="false"
        ref="designerV3"
        @shareClicked="designerV3ShareClicked"
      />
      <div class="user-instructions" v-else>
        <span
          >Enter Date Range, select some Warehouse and Part Type, then click on
          <strong>Preview Stock Balance</strong> to get started</span
        >
      </div>
    </div>

    <PopupV2
      class="email-popup"
      :show="showEmailPopup"
      icon="https://dsmlib.logistics.systems/Icons/BlackMail.png"
      :buttons="emailPopupButtons"
      title="Email Stock Balance"
      width="60%"
      @buttonClicked="emailPopupButtonClicked"
    >
      <div class="email-popup-content-container">
        <div class="mail-inputs-container">
          <div class="email-input-container">
            <EmailInput :mails.sync="emailPopupToMails" title="To" />
          </div>
          <div class="email-input-container">
            <EmailInput :mails.sync="emailPopupCCMails" title="CC" />
          </div>
          <div class="email-input-container">
            <EmailInput :mails.sync="emailPopupBCCMails" title="BCC" />
          </div>
        </div>
        <div class="email-content-inputs-container">
          <Input :inputValue.sync="emailPopupSubjectInputValue" placeholder="Subject" validator="text,100" />
          <RemarksBox title="Message" :text.sync="emailPopupMessageText" :maxLength="1000" />
        </div>
      </div>
    </PopupV2>
  </div>
</template>
<script>
export default {
  components: {},
  computed: {
    previewDisabled() {
      return (
        // !this.dateStart ||
        this.warehouseListTableSelectedRows.length < 1 || this.partTypeListTableSelectedRows.length < 1
      );
    },
  },
  data: function () {
    return {
      dateStart: null,
      dateEnd: null,

      warehouseOpen: true,
      warehouseList: [],
      warehouseListTableLoading: false,
      warehouseListTableSelectedRows: [],

      partTypeOpen: true,
      partTypeList: [],
      partTypeListTableLoading: false,
      partTypeListTableSelectedRows: [],

      showDesignerV3: false,
      designerV3ReportFiles: [],
      designerV3ReportData: [],
      designerV3SharedData: [],
      designerV3ShareBehaviour: {
        behaviour: 'uploadAndEmit',
        options: {
          fileName: '',
          folder: '',
        },
      },

      showEmailPopup: false,
      emailPopupButtons: [{ text: 'Send Email' }, { text: 'Cancel', color: 'lightgray' }],
      emailPopupToMails: [],
      emailPopupCCMails: [],
      emailPopupBCCMails: [],
      emailPopupSubjectInputValue: '',
      emailPopupMessageText: '',

      reportTypeValue: { label: 'Summary', value: 'summary' },
      reportTypeList: [
        { label: 'Summary', value: 'summary' },
        { label: 'Detailed', value: 'detailed' },
      ],
    };
  },
  props: {},
  methods: {
    async getWarehouseList() {
      this.warehouseListTableLoading = true;
      this.warehouseList = (await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'WAREHOUSE' })).map(
        (item, index) => ({ '#': index + 1, ...item }),
      );
      this.warehouseListTableLoading = false;
    },

    async getPartTypeList() {
      this.partTypeListTableLoading = true;
      this.whProductList = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'whproduct' });
      const result = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'EMSPARTTYPE' });
      this.partTypeList = result.map((item) => {
        const { 'Part Type': PartType } = item;
        const whprod = this.whProductList.find((prod) => prod['Product Code'] == PartType);
        const { 'Product ID': TxnID, Size } = whprod || {};
        return {
          ...item,
          label: `${item['Part Type']} - ${item.Description}`,
          ProdTxnID: TxnID,
          Size: Size ?? '',
        };
      });
      this.partTypeListTableLoading = false;
    },

    async previewClicked() {
      if (!this.dateStart) this.dateStart = new Date('1900-01-01');
      if (this.dateStart && !this.dateEnd) this.dateEnd = new Date();
      if (!this.reportTypeValue) this.reportTypeValue = this.reportTypeList[0];
      this.$fullscreenLoading('Getting Stock Info...');
      const { value: reportType } = this.reportTypeValue;
      const requestBody = {
        datestart: new Date(this.dateStart).formatString('yyyy-MM-dd'),
        dateend: new Date(this.dateEnd).formatString('yyyy-MM-dd'),
        warehouse: this.warehouseListTableSelectedRows.map((warehouse) => warehouse['Warehouse Code']).join(','),
        parttype: this.partTypeListTableSelectedRows.map((parttype) => parttype['Part Type']).join(','),
        reporttype: reportType,
      };

      const result = await this.$apiCallV2('/PartInventory/PrintStockBalance', requestBody);
      this.$fullscreenLoading();
      const reportDate = () => {
        const date = new Date();

        // Day, Month, Year
        const dd = String(date.getDate()).padStart(2, '0');
        const MM = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const yyyy = date.getFullYear();

        // Hours, Minutes, Seconds
        let hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

        // AM/PM
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12; // convert 0 -> 12
        const hh = String(hours).padStart(2, '0');

        return `${dd}/${MM}/${yyyy} ${hh}:${minutes}:${seconds} ${ampm}`;
      };

      const stockBal = this.convertToArray(result.PrintStockBalance.Stock);

      let stockInfo = [];

      let formatString = '';

      if (reportType == 'summary') {
        formatString = 'ProductBalanceSummary.json';

        const groupedStockBal = Object.values(
          stockBal.reduce((acc, item) => {
            if (!acc[item.WhseCode]) {
              acc[item.WhseCode] = { WhseCode: item.WhseCode, Items: [] };
            }
            acc[item.WhseCode].Items.push({
              prodCode: item.prodCode,
              description: item.description,
              Balance: item.Balance,
              PackageCode: item.PackageCode,
            });
            return acc;
          }, {}),
        );
        stockInfo = [
          {
            page: '{{jsreportPageNum}} of {{jsreportTotalPage}}',
            warehouseParts: groupedStockBal.map((warehouse) => {
              const { WhseCode, Items } = warehouse;
              const { Name: whseName } = this.warehouseList.find((item) => item['Warehouse Code'] == WhseCode) || {};
              return {
                warehouseName: `[${WhseCode}] ${whseName}`,
                productList: Items.map((item) => {
                  const { Balance, PackageCode, description, prodCode } = item;

                  return {
                    productName: `[${prodCode}] ${description}`,
                    productQty: this.formatNumber(parseInt(Balance) || 0),
                    productPkgCode: PackageCode,
                  };
                }),
              };
            }),
          },
        ];
      } else if (reportType == 'detailed') {
        formatString = 'ProductBalanceDetailed.json';

        const addTotalPrice = stockBal.map((item) => {
          const { Qty, UnitPrice } = item;
          const price = UnitPrice ?? '0';
          const totalPrice = parseFloat(Qty) * parseFloat(price);
          return { ...item, UnitPrice: price, totalPrice: totalPrice };
        });

        const groupByWhse = Object.values(
          addTotalPrice.reduce((acc, item) => {
            const key = item.WhseCode;

            if (!acc[key]) {
              acc[key] = {
                whsecode: key,
                items: [],
              };
            }

            acc[key].items.push(item);
            return acc;
          }, {}),
        );
        
        stockInfo = [
          {
            warehouse: groupByWhse.map((whse) => {
              const { items, whsecode } = whse;

              const groupedByProdCode = Object.values(
                items.reduce((acc, item) => {
                  const key = item.ProdCode;

                  if (!acc[key]) {
                    acc[key] = {
                      prodcode: key,
                      items: [],
                    };
                  }

                  acc[key].items.push(item);
                  return acc;
                }, {}),
              );

              const itemSumQty = items.reduce((acc, item) => {
                const qty = parseFloat(item.Qty);
                return isNaN(qty) ? acc : acc + qty;
              }, 0);

              const itemSumPrice = items.reduce((acc, item) => {
                const price = parseFloat(item.totalPrice);
                return isNaN(price) ? acc : acc + price;
              }, 0);

              return {
                warehouseCode: whsecode,
                warehouseName: this.warehouseList.find((warehouse) => warehouse['Warehouse Code'] == whsecode).Name,
                product: groupedByProdCode.map((prod) => {
                  const { prodcode, items } = prod;

                  const sumQty = items.reduce((acc, item) => acc + parseFloat(item.Qty), 0);
                  const sumPrice = items.reduce((acc, item) => acc + parseFloat(item.totalPrice), 0);

                  return {
                    prodCode: prodcode,
                    prodName: this.partTypeList.find((parttype) => parttype['Part Type'] == prodcode).Description,
                    productItem: items.map((item, index) => {
                      const { SerialNo, Model, DONO, PONO, Qty, SppCode, PackageCode, UnitPrice, totalPrice, GRNNo } =
                        item;

                      const UnitPriceCheck =
                        UnitPrice ?
                          isNaN(UnitPrice) ? '0'
                          : UnitPrice
                        : '0';
                      const totalPriceCheck =
                        totalPrice ?
                          isNaN(totalPrice) ? '0'
                          : totalPrice
                        : '0';

                      return {
                        index: index + 1,
                        serialNo: SerialNo ?? '',
                        model: Model ?? '',
                        doNo: DONO ?? '',
                        poNo: PONO ?? '',
                        sppCode: SppCode ?? '',
                        qty: this.formatNumber(Qty),
                        packageCode: PackageCode ?? '',
                        unitPrice: this.$currencyFormat(UnitPriceCheck),
                        totalPrice: this.$currencyFormat(totalPriceCheck),
                        grnNo: GRNNo ?? '',
                      };
                    }),
                    sumQty: this.formatNumber(sumQty),
                    sumPrice: this.$currencyFormat(sumPrice),
                  };
                }),
                warehouseQty: this.formatNumber(itemSumQty),
                warehousePrice: this.$currencyFormat(itemSumPrice),
              };
            }),
          },
        ];
      }

      const designerFiles = {
        general: {
          companyName: this.$store.state.loginDetails.CoName,
          reportDate: reportDate(),
          dateStart: new Date(this.dateStart).formatString('dd/MM/yyyy'),
          dateEnd: new Date(this.dateEnd).formatString('dd/MM/yyyy'),
          page: '{{jsreportPageNum}} of {{jsreportTotalPage}}',
        },

        stock: stockInfo,
      };

      this.designerV3ReportFiles = Array.from({ length: designerFiles.stock.length }, () => formatString);
      this.designerV3ReportData = designerFiles.stock;
      this.designerV3SharedData = designerFiles.general;
      this.showDesignerV3 = true;
    },

    designerV3ShareClicked: function (shareLink) {
      if (this.designerV3ReportData[0].email) {
        this.emailPopupToMails = this.designerV3ReportData[0].email.split(';').map((email) => ({
          email: email.trim(),
          valid: true,
        }));
      } else {
        this.emailPopupToMails = [];
      }
      this.emailPopupCCMails = [];
      this.emailPopupBCCMails = [];

      this.emailPopupSubjectInputValue = 'Stock Balance';
      this.emailPopupMessageText = `Stock Balance: ${shareLink}\n\n`;

      this.showEmailPopup = true;
    },

    emailPopupButtonClicked: async function (buttonText) {
      if (buttonText === 'Cancel') {
        this.showEmailPopup = false;
        return;
      }

      if (this.emailPopupToMails.filter((mail) => mail.valid).length === 0) {
        this.$showAlert('error', 'No Valid Email', "Please enter at least one valid 'To' email address", [
          { text: 'OK' },
        ]);
        return;
      }

      if (!this.emailPopupSubjectInputValue.trim()) {
        const proceedWithoutSubject = await this.$showAlert(
          'warning',
          'No Subject',
          'No subject was entered\nProceed to email without a subject?',
          [{ text: 'Proceed' }, { text: 'Cancel', color: 'lightgray' }],
        );

        if (proceedWithoutSubject === 'Cancel') return;
      }

      const requestBody = {
        emaillist: [
          {
            doctype: 'STOCKBALANCE',
            docno: `STOCKBALANCE ${this.designerV3SharedData.reportDate}`,
            docnofieldname: '',
            recipient: this.emailPopupToMails.map((mail) => mail.email).join(';'),
            cc: this.emailPopupCCMails.map((mail) => mail.email).join(';'),
            bcc: this.emailPopupBCCMails.map((mail) => mail.email).join(';'),
            subject: this.emailPopupSubjectInputValue.trim(),
            message: this.emailPopupMessageText,
          },
        ],
      };

      this.$fullscreenLoading('Sending Email');
      const sendEmailResponse = await this.$apiCallV2('/PartInventory/SendEmail', requestBody);
      this.$fullscreenLoading();

      if (sendEmailResponse?.trim?.()?.endsWith?.('queue to send.')) {
        this.$showAlert('success', 'Email successfully sent', 'Your email has been successfully sent', [
          { text: 'OK' },
        ]);
        this.showEmailPopup = false;
      } else {
        this.$showAlert('error', 'Email not sent', 'Your email could not be sent. Please try again.', [{ text: 'OK' }]);
      }
    },

    convertToArray(item) {
      if (!item) return [];
      return Array.isArray(item) ? item : [item];
    },

    formatNumber(value) {
      return Number(value).toLocaleString('en-US');
    },
  },
  mounted() {
    this.getWarehouseList();
    this.getPartTypeList();
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';
.main {
  padding: 10px 45px;
  display: flex;
  flex-direction: row;
  font-size: 12px;
  > .left-container {
    height: 100%;
    width: 50%;

    display: flex;
    flex-direction: column;
    gap: 3px;
  }

  .table-wrapper {
    flex: 0 0 30px;
    width: 100%;
    border-radius: 5px;
    overflow: hidden;
    background-color: white;
    overflow: hidden;
    transition: all 0.15s ease;
    display: flex;
    flex-direction: column;

    .accordion-header {
      min-height: 30px;
      padding: 0px 10px;
      display: flex;
      align-items: center;
      font-size: 1rem;
      font-weight: bold;
      cursor: pointer;
      position: relative;
      border-bottom: 1px solid lightgray;
      transition: all 0.1s ease;
      &::after {
        position: absolute;
        content: '▼';
        right: 10px;
        transform: translateY(-10%) rotate(0deg);
        transition: transform 0.25s ease;
      }
      &:hover {
        background-color: #f0f0f0;
      }
    }

    &.open {
      flex: 1;
      transition: all 0.25s ease;
      & .accordion-header::after {
        transform: translateY(10%) rotate(-180deg);
      }
    }

    .table-box-main {
      padding: 0px 5px 5px 5px;
    }
  }

  > .right-container {
    height: 100%;
    width: 50%;
    margin-left: 5px;
    border-radius: 5px;
    overflow: hidden;
    background-color: white;
    display: flex;
    flex-direction: column;

    .user-instructions {
      font-size: 1.25rem;
      padding: 3rem;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
    }
  }

  .filter-table-controls {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    // margin-bottom: 2px;

    > .filter-summary-container {
      margin-right: 5px;
      align-content: center;
      text-align: end;
    }

    .filter-content {
      text-align: left;
      cursor: auto;

      .refresh-button {
        margin-top: 10px;
        display: flex;
        justify-content: flex-end;
      }
    }

    > .select-deselect-all-button {
      margin-left: 5px;
    }
  }
  .email-popup {
    .email-popup-content-container {
      display: flex;
      flex-direction: row;

      > .mail-inputs-container {
        margin-right: 5px;
        display: flex;
        flex-direction: column;
        flex: 1;

        > .email-input-container {
          margin-bottom: 5px;
        }
      }

      > .email-content-inputs-container {
        margin-left: 5px;
        display: flex;
        flex-direction: column;
        flex: 2;
      }
    }
  }
}
</style>
